import React from "react";

export default class MsField extends React.PureComponent {
    constructor(props) {
        super(props);
        this.handleFieldChange = this.handleFieldChange.bind(this);
    }

    handleFieldChange(e) {
        if (this.props.onChange) {
            this.props.onChange(e.target.value);
        }
    }

    render() {
        let divClass =
            "ui icon input formRow--input-wrapper js-inputWrapper " +
            this.props.classes; // <%= payload %>
        let divId = this.props.id + "_field";
        let type = this.props.type ? this.props.type : "text";
        let extraComponent = this.props.extra ? this.props.extra : null;
        let errorStyle = this.props.showError
            ? {
                  borderColor: "#FF0000",
              }
            : {};
        let inputError = this.props.errorMsg ? this.props.errorMsg : null;
        //console.log(inputError, this.props.errorMsg)

        return (
            <div className="field">
                <fieldset className="formRow">
                    {inputError ? (
                        <p
                            style={{
                                color: "#FF0000",
                                lineHeight: "10px",
                                fontSize: "13px",
                                marginBottom: "6px",
                            }}
                        >
                            {inputError}
                        </p>
                    ) : null}
                    <>
                        <label style={{ fontSize: "12px" }} for={this.props.id}>
                            {this.props?.label}
                        </label>
                        <div id={divId} className={divClass}>
                            {extraComponent}
                            <>
                                <input
                                    key={this.props.id}
                                    onChange={this.handleFieldChange}
                                    type={type}
                                    className="formRow--input js-input"
                                    style={errorStyle}
                                    name={this.props.id}
                                    id={this.props.id}
                                    placeholder={this.props.label}
                                    value={this.props.value}
                                />
                            </>
                        </div>
                    </>
                </fieldset>
            </div>
        );
    }
}
